import { get, post, put, remove as httpRemove } from "../Services/http";
import { catchError } from "./Error.action";
const rootRoute = "/api/orderhistory";

export const SET_ORDERS = "SET_ORDERS";
export const SET_LOADING = "SET_LOADING";

export const setOrders = (orderItems) => ({
  type: SET_ORDERS,
  payload: {
    orderItems,
  },
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: {
    loading,
  },
});

export const getOrders = (page, showOnlyMyOrders) => (dispatch) => {
  return get(`${rootRoute}?page=${page}&showMyOrders=${showOnlyMyOrders}`)
    .then((response) => response.json())
    .then((result) => {
      dispatch(setOrders(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const goToDetail = (orderId) =>{
  const url = new URL(window.location);
  url.searchParams.set("currentTab", "orderTab")
  url.searchParams.set("id", orderId)
  window.history.pushState({}, '', url);
  window.dispatchEvent(new Event("popstate"))
}